import { Link } from "react-router-dom";

export const Logo = ({ className = "h-9", to = "/" }) => (
  <Link to={to} data-testid="brand-logo" className="inline-flex items-center">
    <img src="/logo.png" alt="LearnAI by IDDCR Global" className={`${className} w-auto object-contain dark:hidden`} />
    <img src="/logo-dark.png" alt="LearnAI by IDDCR Global" className={`${className} hidden w-auto object-contain dark:block`} />
  </Link>
);
